var map = {
	"./accenture.jpeg": 185,
	"./amazon.png": 484,
	"./cloud-mentor.jpeg": 659,
	"./cognizant.webp": 418,
	"./cool-background.png": 889,
	"./deloitte.png": 42,
	"./elastic-run.jpeg": 833,
	"./facebook.png": 595,
	"./flipkart.jpeg": 567,
	"./flp.jpeg": 614,
	"./ibm.jpeg": 882,
	"./infosys.png": 837,
	"./myntra.png": 445,
	"./naukri.png": 461,
	"./optum.png": 498,
	"./oracle.png": 785,
	"./paytm.png": 159,
	"./sap.jpeg": 436,
	"./synopsys.png": 265,
	"./tcs.webp": 505,
	"./tech-mahindra.png": 579,
	"./tesla.png": 248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;